import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class SettingService {
    constructor(private http: HttpClient) {}

    getSettingByName(name: string): Observable<any> {
        return this.http.get(environment.api_url + `/config/setting/get-by-name?name=${name}`);
    }

    list(): Observable<any> {
        return this.http.get(environment.api_url + `/config/setting/list`);
    }

    update(id, data): Observable<any> {
        return this.http.post(environment.api_url + `/config/setting/${id}/update`, data);
    }
}
